(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aap-page-share"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('aap-page-share')){
  customElements.define('aap-page-share',class extends HTMLElement{
    connectedCallback(){
      if(this.shareEvents)return;
      this.shareEvents=new AbortController();
      const options={signal:this.shareEvents.signal};
      const details=this.querySelector('details');
      const summary=this.querySelector('summary');
      const status=this.querySelector('[role="status"]');
      const copy=this.querySelector('[data-copy]');
      const native=this.querySelector('[data-native]');
      if(!details||!copy||!native)return;
      copy.hidden=false;
      native.hidden=typeof navigator.share!=='function';
      copy.addEventListener('click',async()=>{
        try{await navigator.clipboard.writeText(this.dataset.url);status.textContent=this.dataset.copied;}
        catch{const fallback=this.querySelector('.aap-page-share__fallback');fallback.hidden=false;const input=fallback.querySelector('input');input.focus();input.select();status.textContent=this.dataset.failed;}
      },options);
      native.addEventListener('click',async()=>{
        try{await navigator.share({title:this.dataset.title,url:this.dataset.url});details.open=false;}
        catch(error){if(error.name!=='AbortError')copy.focus();}
      },options);
      this.addEventListener('keydown',event=>{if(event.key==='Escape'&&details.open){details.open=false;summary.focus();}},options);
      document.addEventListener('pointerdown',event=>{if(details.open&&!this.contains(event.target))details.open=false;},options);
      this.addEventListener('focusout',event=>{if(event.relatedTarget&&!this.contains(event.relatedTarget))details.open=false;},options);
    }
    disconnectedCallback(){this.shareEvents?.abort();this.shareEvents=null;}
  });
}
  } catch(e) { console.error(e); }
})();

})();
